import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { LocaleRouterService } from '@shared/services/locale-router.service';
import { Subject, Subscription, interval } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Component({
    selector: 'inka-exit',
    templateUrl: './exit.component.html',
    styleUrls: ['./exit.component.scss'],
    standalone: false
})
export class ExitComponent implements OnInit, OnDestroy {

  private clickSubject = new Subject<void>();

  private subscription?: Subscription;

  @HostListener('click', ['$event.target'])
  onClick() {
    this.clickSubject.next(void 0);
  }

  constructor(private router: LocaleRouterService) {
  }

  ngOnInit(): void {
    this.subscription = interval(2000)
      .pipe(
        take(1),
        switchMap(() => this.clickSubject),
        take(1))
      .subscribe(() => this.router.games());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
